import {
  ImageOptimizerAction,
  LOAD_IMAGE_OPTIMIZER,
  LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE,
  LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_FAIL,
  LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_SUCCESS,
  LOAD_IMAGE_OPTIMIZER_FAIL,
  LOAD_IMAGE_OPTIMIZER_SUCCESS,
  LoadImageOptimizer,
  LoadImageOptimizerAutoOptimize,
  LoadImageOptimizerAutoOptimizeFail,
  LoadImageOptimizerAutoOptimizeSuccess,
  LoadImageOptimizerSuccess,
  SET_BOOSTER_STATS,
  SetBoosterStats
} from "../actions";

export interface ImageOptimizerStats {
  notCompressed: number;
  notCompressedFull: number;
  notCompressedSize: number;
  reducedSize: number;
  reducedPercent: number;
  lastCompressedSize: number;
  lastCompressedPercent: number;
  compressedFull: number;
  compressedThumbs: number;
  compressedOther: number;
  pagesCompressed: Array<any>;
  compressIsRunning: boolean;
  planLimit: number;
  limitResetDate: any;
  usedCountFromLimit: number;
}


export interface IImageOptimizerEntityState {
  loading: boolean;
  loaded: boolean;
  stats: ImageOptimizerStats;
  autoOptimizeEnabled: boolean;
}

export interface ImageOptimizerState {
  entities: {[websiteId: number]: IImageOptimizerEntityState};
  loading: boolean;
  loaded: boolean;
}

export const initialState: ImageOptimizerState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: ImageOptimizerState = initialState, action: ImageOptimizerAction): ImageOptimizerState {
  let payload: any;

  switch (action.type) {

    case SET_BOOSTER_STATS:
      payload = (<SetBoosterStats>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            stats: payload.stats
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER:
      payload = (<LoadImageOptimizer>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false,
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER_SUCCESS:
      payload = (<LoadImageOptimizerSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            stats: payload.stats,
            loading: false,
            loaded: true,
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER_FAIL:
      payload = (<LoadImageOptimizer>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true,
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE:
      payload = (<LoadImageOptimizerAutoOptimize>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false,
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_SUCCESS:
      payload = (<LoadImageOptimizerAutoOptimizeSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            autoOptimizeEnabled: payload.autoOptimizeEnabled,
            loading: false,
            loaded: true,
          }
        }
      };

    case LOAD_IMAGE_OPTIMIZER_AUTO_OPTIMIZE_FAIL:
      payload = (<LoadImageOptimizerAutoOptimizeFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true,
          }
        }
      };

  }

  return state;
}
